import { IGAO } from '../../../../igao'

function Resources () {
  return (
    <div className='main'>
      <IGAO
        path='resources'
        withTopMargin={false}
      />
    </div>
  )
}

export default Resources
